import { createQueryBuilderV4 } from "@odata2ts/odata-query-builder";
import { QAPPMain_GF_SendEngraverPrinterData } from "../../odata/appu4dm/QAppU4DM";
import { odataFetch } from "../../lib/odata-fetch";
import {
  APPMain_GF_SendEngraverPrinterData2Params,
  APPMain_GF_SendEngraverPrinterDataResponse,
} from "../../odata/appu4dm/AppU4DMModel";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useMTUs } from "../mtu/use-mtus";
import { useMachine } from "../machine/use-machine";
import { taskKeys } from "./task-keys";

export function useSendEngraverPrinterData() {
  const { machine } = useMachine();
  const { selected } = useMTUs();
  const queryClient = useQueryClient();
  const { token } = queryClient.getDefaultOptions().queries?.meta ?? {};

  const { mutate, ...mutation } = useMutation({
    mutationFn: (taskId: string) =>
      sendEngraverPrinterData(
        {
          taskId,
          machineId: machine!.EquipmentNId!,
          mtu: selected!.DM_MaterialTrackingUnit.MaterialTrackingUnit.Code!,
        },
        token!
      ),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: taskKeys.getProductsWaitingForValidation(
          machine?.EquipmentNId,
          selected?.DM_MaterialTrackingUnit.MaterialTrackingUnit.Code
        ),
      });
    },
  });

  return {
    sendEngraverPrinterData: mutate,
    ...mutation,
  };
}

type Payload = {
  mtu: string;
  taskId: string;
  machineId: string;
};

async function sendEngraverPrinterData(payload: Payload, token: string) {
  const builder = createQueryBuilderV4(
    "APPMain_GF_SendEngraverPrinterData",
    new QAPPMain_GF_SendEngraverPrinterData()
  );

  return odataFetch<
    APPMain_GF_SendEngraverPrinterDataResponse,
    APPMain_GF_SendEngraverPrinterData2Params
  >({
    builder,
    method: "POST",
    token,
    body: {
      command: {
        ProductId: payload.mtu,
        TaskId: payload.taskId,
        WorkCenter: payload.machineId,
      },
    },
  });
}
